import { CardSkeleton, DashCard } from "../DashboardCards";
import { Box } from "@mui/material";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { BarTip } from "../DashboardTooltip";
import { COLORS } from "../../configs/config";

export const AreasChart = ({ data, loading }) => {
    if (loading) return <CardSkeleton height={200} />;

    const currentYear = new Date().getFullYear();
    const yearData = data?.find((y) => y.year === currentYear) ?? data?.[0];
    const areas = yearData?.data ?? [];

    const chartData = areas
        .map((a) => ({
            nome: a.area?.nome ?? "—",
            total: (a.meses ?? []).reduce((s, m) => s + (m.totalItens ?? 0), 0),
        }))
        .sort((a, b) => b.total - a.total)
        .slice(0, 6);

    return (
        <DashCard title="Requisições fora de regra por área" tag={String(currentYear)}>
            <Box sx={{ position: "relative", height: Math.max(chartData.length * 40 + 60, 160) }}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={chartData} layout="vertical" margin={{ top: 4, right: 16, left: 4, bottom: 0 }}>
                        <XAxis
                            type="number"
                            tick={{ fill: COLORS.tDim, fontSize: 9 }}
                            axisLine={{ stroke: COLORS.border }}
                            tickLine={false}
                        />
                        <YAxis
                            type="category"
                            dataKey="nome"
                            tick={{ fill: COLORS.tSec, fontSize: 10 }}
                            axisLine={false}
                            tickLine={false}
                            width={80}
                        />
                        <Tooltip content={<BarTip />} cursor={{ fill: `${COLORS.kpiBg}` }} />
                        <Bar dataKey="total" name="Requisições" fill={COLORS.chartBar1} radius={[0, 4, 4, 0]} maxBarSize={18} />
                    </BarChart>
                </ResponsiveContainer>
            </Box>
        </DashCard>
    );
};